import React, { Fragment } from "react";
import Grid from '@mui/material/Grid2';
import TicketStatus from "@common/components/ListDetailViews/ListView/TicketStatus";
import { displayDateTime, fromNow } from "@common/utils/localTime.utils";
import { TFunction } from "react-i18next";
import { TicketEntity } from "@pages/Tickets/ListView/colDefs";
import ListTypography from "../../../../common/components/ListDetailViews/ListView/ListTypography";
import ListIndicator from "@common/components/ListDetailViews/ListView/ListIndicator";
import { ColDefWithTab } from "../FilterColumn/context";
import TicketPriority from "@pages/Tickets/ListView/TicketPriority";
export const MIN_FIXED_SIZE = 120;
export const getColumns = (
  onTicketClick: (id: TicketEntity["id"]) => void,
  t: TFunction
): ColDefWithTab<TicketEntity>[] => [
  {
    label: "Ticket ID",
    key: "id",
    sortable: true,
    default: true,
    disabledToHide: true,
    render: ({ id, priority }) =>
      id !== undefined ? (
        <Grid
          container
          direction="row"
          sx={{ width: '100%', justifyContent: "center", }}
        >
          <TicketStatus
            id={id.toString()}
            priority={(priority as TicketsPriorityFilter) ?? "Informational"}
            onClick={onTicketClick}
          />
        </Grid>
      ) : (
        <Fragment />
      ),
  },
  {
    label: "Issue",
    key: "issue",
    sortable: true,
    default: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ issue }) => <ListTypography cellValue={issue} />,
  },
  {
    label: "Last Update",
    key: "updatedAt",
    width: 140,
    minWidth: MIN_FIXED_SIZE,
    default: true,
    sortable: true,
    render: ({ updatedAt }) => (
      <ListTypography
        tooltip={updatedAt ? displayDateTime(updatedAt) : ""}
        cellValue={t(...fromNow(updatedAt ?? 0))}
      />
    ),
  },
  {
    label: "Opened",
    key: "createdAt",
    default: true,
    width: 140,
    minWidth: MIN_FIXED_SIZE,
    sortable: true,
    render: ({ createdAt }) => (
      <ListTypography
        tooltip={createdAt ? displayDateTime(createdAt) : ""}
        cellValue={t(...fromNow(createdAt ?? 0))}
      />
    ),
  },
  {
    label: "Cleared",
    key: "cleared",
    default: true,
    minWidth: MIN_FIXED_SIZE,
    sortable: true,
    render: ({ cleared }) => <ListIndicator active={cleared} />,
  },
  {
    label: "Trigger",
    key: "triggerName",
    default: true,
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ triggerName }) => <ListTypography cellValue={triggerName} />,
  },
  {
    label: "Status",
    key: "state",
    default: true,
    width: 130,
    minWidth: MIN_FIXED_SIZE,
    sortable: true,
    render: ({ state }) => (
      <ListTypography
        cellValue={
          state == "Open"
            ? t("Open")
            : state == "Closed"
            ? t("Closed")
            : t("Pending Close")
        }
      />
    ),
  },
  {
    key: "priority",
    label: "Priority",
    sortable: true,
    render: ({ priority }) => (
      <Grid
        container
        direction="row"
        sx={{ width: '100%', justifyContent: "center", }}
      >
        <TicketPriority priority={priority} label={t(priority)} />
      </Grid>
    ),
  },
  {
    label: "Sync Status",
    key: "syncStatus",
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ syncStatus }) => <ListTypography cellValue={syncStatus} />,
  },
  {
    label: "Date Synced",
    key: "syncDate",
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ syncDate }) => (
      <ListTypography
        tooltip={syncDate ? displayDateTime(syncDate) : ""}
        cellValue={syncDate ? t(...fromNow(syncDate)) : "-"}
      />
    ),
  },
  {
    label: "TAL State",
    key: "talState",
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ talState }) => <ListTypography cellValue={talState} />,
  },
  {
    label: "TAL Case Number",
    key: "talCaseNo",
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ talCaseNo }) => <ListTypography cellValue={talCaseNo} />,
  },
  {
    label: "Assigned To",
    key: "assignedTo",
    sortable: true,
    minWidth: MIN_FIXED_SIZE,
    render: ({ assignedTo }) => <ListTypography cellValue={assignedTo} />,
  },
  {
    label: "Third Party Ticket ID",
    key: "thirdPartyTicketId",
    sortable: true,
    render: ({ thirdPartyTicketId }) => (
      <ListTypography cellValue={thirdPartyTicketId} />
    ),
  },
];
